export default __webpack_public_path__ + "static/media/book.4b60aa6c.svg";